<div class="container mt-2 ">
    <div class="container">

        <h4 class="text-left">Panel Items ({{code}})</h4>

        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngFor="let p of products">
                <div class="prod-block" (click)="goToProductDetails(p.sku)">
                    <div>
                        <img src="{{getImage(p.image)}}" class="img-fluid" alt="...">
                    </div>
                    <div>
                        {{p.name}}
                    </div>

                </div>

            </div>
        </div>
        <!--    <ul>-->
        <!--        <li *ngFor="let item of products ; let i = index">-->
        <!--            <div class="row">-->
        <!--                <div class="col-12">-->
        <!--                    <div class="col-1 pull-left">-->
        <!--                        <img src="{{getImage(item.image)}}" class="img-fluid" alt="...">-->
        <!--                    </div>-->

        <!--                    <div class="col-11 pull-right">-->
        <!--                        <div class="row">-->
        <!--                            <div class="col-12">-->

        <!--                                <div class="row">-->
        <!--                                    <div class="col-12 text-left"><b i18n>Name:</b> {{item.name}}</div>-->
        <!--                                </div>-->

        <!--                                <div class="row">-->
        <!--                                    <div class="col-12 text-left"><b i18n>Price:</b> {{item.price}}</div>-->
        <!--                                </div>-->


        <!--                                <div class="row">-->
        <!--                                    <div class="col-12 text-right">-->
        <!--                                        <button class="btn btn-primary"-->
        <!--                                                (click)="goToProductDetails(item.sku)"-->
        <!--                                                style="padding-right: 20px ; padding-left: 20px"> Details-->
        <!--                                        </button>-->
        <!--                                    </div>-->

        <!--                                </div>-->

        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--        </li>-->
        <!--    </ul>-->

    </div>
</div>
